const ESC_KEY_CODE = 27

export class EscManager {
    constructor() {
        this._escMap = new Map()

        document.body.addEventListener('keydown', this._handleKeydown)
    }

    static getInstance() {
        if (!EscManager._instance) {
            EscManager._instance = new EscManager()
        }

        return EscManager._instance
    }

    addCallback(callback) {
        this._escMap.set(callback, callback)
    }

    removeCallback(callback) {
        if (this._escMap.has(callback)) {
            this._escMap.delete(callback)
        }
    }

    _handleKeydown = (e) => {
        if (e.keyCode === ESC_KEY_CODE && this._escMap.size !== 0) {
            this._invokeCallbacks(e)
        }
    }

    _invokeCallbacks(e) {
        const callbacksArray = Array.from(this._escMap.values())
        let shouldPassControlToNextEsc
        const callback = () => (shouldPassControlToNextEsc = true)

        for (let i = callbacksArray.length - 1; i >= 0; i--) {
            shouldPassControlToNextEsc = false
            callbacksArray[i](e, callback)

            if (shouldPassControlToNextEsc) {
                continue
            }

            break
        }
    }
}



// WEBPACK FOOTER //
// ./singletons/EscManager.js